import { Card, CardContent, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

import StatsOtherGraphPatientEventModule from './graph/StatsOtherGraphPatientEventModule'
import {
  StatsPatientEventAccount,
  StatsDeviceTypeBreakdown,
} from './graph/StatsTopStatsExamTypePie'

export default function StatsDashboard() {
  return (
    <div
      style={{
        display: 'flex',
        padding: 25,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: 'block' }}>
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="h4">Tableau de bord statistique</Typography>
              <Typography variant="body2" color="text.secondary">
                Vue d&apos;ensemble des principaux indicateurs patients et
                examens.
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Card sx={{ height: 400, borderRadius: 3 }}>
                  <CardContent>
                    <Typography variant="h5">
                      Consultation des documents patients
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ marginBottom: 2 }}
                    >
                      Répartition des consultations des ordonnances, images et
                      comptes rendus.
                    </Typography>
                    <StatsOtherGraphPatientEventModule />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card sx={{ height: 400, borderRadius: 3 }}>
                  <CardContent>
                    <Typography variant="h5">
                      Répartition par type d&apos;appareil
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ marginBottom: 2 }}
                    >
                      Distribution des accès selon l&apos;appareil utilisé par
                      les patients.
                    </Typography>
                    <Box sx={{ height: 300 }}>
                      <StatsDeviceTypeBreakdown />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Card sx={{ height: 400, borderRadius: 3 }}>
                  <CardContent>
                    <Typography variant="h5">
                      Patients avec ou sans compte
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ marginBottom: 2 }}
                    >
                      Comparaison par tranche d&apos;âge entre patients
                      disposant d&apos;un compte et les autres.
                    </Typography>
                    <Box sx={{ height: 300 }}>
                      <StatsPatientEventAccount />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}
